import { createRouter, createWebHistory } from 'vue-router'
import Dashboard from '../views/Dashboard.vue'
import TemporaryKeys from '../views/TemporaryKeys.vue'
import AccessInstructions from '../views/AccessInstructions.vue'
import Profile from '../views/Profile.vue'
import CallTool from '../views/CallTool.vue'
import OperationData from '../views/OperationData.vue'
import Recharge from '../views/Recharge.vue'

// 新增子路由对应的组件
import AccessOverview from '../views/AccessInstructions/Overview.vue'
import AccessConfigGeneration from '../views/AccessInstructions/ConfigGeneration.vue'
import AccessGetAccessKey from '../views/AccessInstructions/GetAccessKey.vue'
import AccessFileUpload from '../views/AccessInstructions/FileUpload.vue'
import AccessFileDownload from '../views/AccessInstructions/FileDownload.vue'
import AccessFilePathQuery from '../views/AccessInstructions/FilePathQuery.vue'
import AccessFileDelete from '../views/AccessInstructions/FileDelete.vue'
// 新增附录组件
import AccessAppendix from '../views/AccessInstructions/Appendix.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue')
  },
  {
    path: '/auth',
    name: 'Auth',
    component: () => import('../views/Auth.vue')
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard
  },
  {
    path: '/temporary-keys',
    name: 'TemporaryKeys',
    component: TemporaryKeys
  },
  {
    path: '/access-instructions',
    name: 'AccessInstructions',
    component: AccessInstructions,
    children: [
      {
        path: 'overview',
        name: 'AccessInstructionsOverview',
        component: AccessOverview
      },
      {
        path: 'config-generation',
        name: 'AccessInstructionsConfigGeneration',
        component: AccessConfigGeneration
      },
      {
        path: 'get-access-key',
        name: 'AccessInstructionsGetAccessKey',
        component: AccessGetAccessKey
      },
      {
        path: 'file-upload',
        name: 'AccessInstructionsFileUpload',
        component: AccessFileUpload
      },
      {
        path: 'file-download',
        name: 'AccessInstructionsFileDownload',
        component: AccessFileDownload
      },
      {
        path: 'file-path-query',
        name: 'AccessInstructionsFilePathQuery',
        component: AccessFilePathQuery
      },
      {
        path: 'file-delete',
        name: 'AccessInstructionsFileDelete',
        component: AccessFileDelete
      },
      // 新增“附录”路由
      {
        path: 'appendix',
        name: 'AccessInstructionsAppendix',
        component: AccessAppendix
      }
    ]
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile
  },
  {
    path: '/call-tool',
    name: 'CallTool',
    component: CallTool
  },
  {
    path: '/operation-data',
    name: 'OperationData',
    component: OperationData
  },
  {
    path: '/recharge',
    name: 'Recharge',
    component: Recharge
  }
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes
})

// 添加全局前置守卫
router.beforeEach((to, from, next) => {
  next();
})

export default router
